module.exports = __webpack_public_path__ + "img/banner_tab3.c039aa21.png";